import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import UpdateFormById from 'ia-react-core/~/actions/form/UpdateFormById';
import SetFormValuesById from 'ia-react-core/~/actions/form/SetFormValuesById';
import SetFormValuesByName from 'ia-react-core/~/actions/form/SetFormValuesByName';
import setFormValuesById from 'ia-react-core/~/actions/form-fn/setFormValuesById';
import setFormValuesByName from 'ia-react-core/~/actions/form-fn/setFormValuesByName';
import setControlValueById from 'ia-react-core/~/actions/form-fn/setControlValueById';
import setControlValueByName from 'ia-react-core/~/actions/form-fn/setControlValueByName';
import SetControlValueById from 'ia-react-core/~/actions/form/SetControlValueById';
import SetControlValueByName from 'ia-react-core/~/actions/form/SetControlValueByName';
import set from 'ia-react-core/~/utils/accessors/set';
import get from 'ia-react-core/~/utils/accessors/get';
import mergeState from '../../../utils/accessors/_mergeState';
import clearFormById from '../../../actions/form-fn/clearFormById';
import clearFormByName from '../../../actions/form-fn/clearFormByName';
import updateFormById from '../../../actions/form-fn/updateFormById';
import { FormComposedProps } from './Form';

export default function formValuesReducer(state: object, action: CoreAction, { formId, name }: FormComposedProps<object>) {
  switch (action.type) {
    case `${clearFormById.type}/${formId}`:
    case `${clearFormByName.type}/${name}`:
      return reduceRlearFormValues(state);
    case `${updateFormById.type}/${formId}`:
      return reduceUpdateFormValues(state, action as UpdateFormById);
    case `${setFormValuesByName.type}/${name}`:
    case `${setFormValuesById.type}/${formId}`:
      return reduceSetFormValues(state, action as SetFormValuesById | SetFormValuesByName);
    case `${setControlValueByName.type}/${name}`:
    case `${setControlValueById.type}/${formId}`:
      return reduceSetControlValue(state, action as SetControlValueById | SetControlValueByName);
    default:
      return state;
  }
}

function reduceRlearFormValues(state: object) {
  return Array.isArray(state) ? [] : {};
}

function reduceUpdateFormValues(state: object, { values, options: { mergeBlacklist } }: UpdateFormById) {
  if (!values) {
    return state;
  }
  return mergeState(state, values as {[index: string]: unknown}, { mergeBlacklist });
}

function reduceSetFormValues(state: object, { values, options }: SetFormValuesById | SetFormValuesByName) {
  if (options?.override) return values;
  return mergeState(state, values as {[index: string]: unknown});
}

function reduceSetControlValue(state: object, { path, value, options }: SetControlValueById | SetControlValueByName) {
  const currentState = get(state, path);
  if (options?.override || !value || typeof currentState !== 'object') return set(state, path, value);

  const newState = mergeState(currentState, value as {[index: string]: unknown});
  return set(state, path, newState);
}
